export const MAPS_ZOOM_DEFAULT_LEVEL = 14;
export const MAPS_ZOOM_MAX_LEVEL = 22;
export const PREFIX_INFO_WINDOW = 'infoWindow_';
export const MAX_BOUNDS_LEVEL = 'country';
export const LAT_EXTEND_BOUND = 3;
export const LNG_EXTEND_BOUND = 10;
export enum DIRECTION_RENDERER {
  ONE_WAY_DIRECTION = 'ONE_WAY_DIRECTION',
  MULTI_POINTS_DIRECTION = 'MULTI_POINTS_DIRECTION',
}
export const DIRECTION_STYLE = {
  LINE: { key: 'LINE', strokeColor: '#f1c40e', strokeWeight: 6, zIndex: 2 },
  DASHED: {
    key: 'DASHED',
    strokeColor: 'transparent',
    strokeWeight: 6,
    zIndex: 1,
    icons: [
      {
        icon: {
          path: 0,
          scale: 2,
          fillOpacity: 0.8,
          fillColor: '#49a8db',
          strokeOpacity: 0.8,
          strokeColor: '#49a8db',
        },
        repeat: '10px',
      },
    ],
  },
};
export const FIT_BOUNDS_PADDING = {
  // default padding all size 10px (mobile), 20px (desktop)
  // breadcrumb--height: 72px (top), slider--height: 152px (bottom)
  MOBILE_SHOW_SLIDER: { top: 82, right: 10, bottom: 162, left: 10 },
  MOBILE_DEFAULT: { top: 82, right: 10, bottom: 10, left: 10 },
  // panel--width: 410px (right) and padding top 30px
  DESKTOP_OPEN_PANEL: { top: 30, right: 430, bottom: 30, left: 30 },
  DESKTOP_DEFAULT: { top: 30, right: 30, bottom: 30, left: 30 },
  HOME_PROFILE_DEFAULT: { top: 20, right: 20, bottom: 20, left: 20 },
};

export const MAP_TYPE = {
  HYBRID: {
    key: 'HYBRID',
    title: 'location.map-type.hybrid',
    imgBackground: 'https://maps.gstatic.com/tactile/layerswitcher/ic_satellite-2x.png',
  },
  ROADMAP: {
    key: 'ROADMAP',
    title: 'location.map-type.roadmap',
    imgBackground: 'https://maps.gstatic.com/tactile/layerswitcher/ic_default-2x.png',
  },
};

export enum MAP_STYLE {
  STANDARD = 'STANDARD',
  SILVER = 'SILVER',
  RETRO = 'RETRO',
  DARK = 'DARK',
  NIGHT = 'NIGHT',
  AUBERGINE = 'AUBERGINE',
}
